import { errorActions, successAction } from "@/alerts";
import axios from "../../../api";
/**
 * Funcion para insertar una venta
 * @param {*} saleID Identificador de la venta
 * @returns El id de la venta registrada
 */
export const infoStateInvoice = async (saleID, cancel = "no") => {
  try {
    const response = await axios.get(`info-comprobante?sale_id=${saleID}&cancel=${cancel}`, {
      method: {
        "Content-Type": "application/json",
      },
    });
    const data = await response.data;
    if (data.msg === true) {
      successAction(
        "Detalles del comprobante",
        `Codigo: ${data?.infoInvoice?.invoiceResponses?.code || "Sin Codigo"} \n\n<br/>
        Fecha: ${data?.infoInvoice?.invoiceResponses?.date || "Sin fecha"} \n\n <br/>

        URL: ${data?.infoInvoice?.invoiceResponses?.url ? `
          <a href="${data?.infoInvoice?.invoiceResponses?.url}" style="color:blue;transform: underline:" target="_blank">Ver en DGII</a>
          `:"Sin url"} \n\n 
        `
      );
      return data.id;
    } else {
      errorActions(
        `Lo sentimos no pudimos reenviar el comprobante de la venta, vuelve a intentarlo mas tarde.`
      );
    }
  } catch (error) {
    errorActions(error);
  }
};
